import { render } from "./CompanionModal.vue?vue&type=template&id=fc9cccbc&scoped=true"
import script from "./CompanionModal.vue?vue&type=script&lang=js"
export * from "./CompanionModal.vue?vue&type=script&lang=js"

import "./CompanionModal.vue?vue&type=style&index=0&id=fc9cccbc&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc9cccbc"]])

export default __exports__